module.exports = __webpack_public_path__ + "img/transferencia_bancaria.a9df2163.svg";